export default __webpack_public_path__ + "static/team-4-dc30bb92d498af111a2104562d598737.png";